import {isMobile} from '../helpers';

const handleHistorySaveItemHover = () => {
  const activeItemClass = 'history-save-item-active';
  const disabledItemClass = 'history-save-item-disabled';

  const items = document.getElementsByClassName('history-save-item');

  Array.from(items).forEach((item, index) => {
    $(item).hover(
      function () {
        animateTransition(this, index);

        $(this).addClass(activeItemClass);

        Array.from(items).forEach((innerItem) => {
          if (!innerItem.classList.contains(activeItemClass)) {
            innerItem.classList.add(disabledItemClass);
          }
        });
      },
      function () {
        animateTransition(this, index);

        $(this).removeClass(activeItemClass);

        Array.from(items).forEach((innerItem) => {
          innerItem.classList.remove(disabledItemClass);
        });
      }
    );
  });
};

var timeout = [];

const animateTransition = (thisArg, index) => {
  window.clearTimeout(timeout[index]);

  $(thisArg).find('.history-save-item-top').css('opacity', 0);

  timeout[index] = window.setTimeout(
    () => $(thisArg).find('.history-save-item-top').animate({opacity: '1'}, {duration: 200}),
    350
  );
};

const HistorySaveComponent = () => {
  if (!isMobile()) {
    handleHistorySaveItemHover();
  }
};

export const HistorySave = () => {
  $(document).ready(() => HistorySaveComponent());
};
